import React, { useEffect, useState, useRef, lazy } from 'react';
import { QuoteIcon } from 'lucide-react';
function LazyVideo({
  videoUrl,
  name
}: {
  videoUrl: string;
  name: string;
}) {
  const [shouldLoad, setShouldLoad] = useState(false);
  const videoRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setShouldLoad(true);
        observer.disconnect();
      }
    }, {
      rootMargin: '200px'
    });
    if (videoRef.current) {
      observer.observe(videoRef.current);
    }
    return () => observer.disconnect();
  }, []);
  return <div ref={videoRef} className="mb-6 relative w-full" style={{
    paddingBottom: '56.25%'
  }} data-id="element-220">
      {shouldLoad ? <iframe title={`Testimonio de ${name}`} src={videoUrl} className="absolute top-0 left-0 w-full h-full rounded-lg shadow-[0_4px_20px_rgba(0,0,0,0.3)]" frameBorder="0" loading="lazy" referrerPolicy="strict-origin-when-cross-origin" allow="fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" allowFullScreen data-id="element-221" /> : <div className="absolute top-0 left-0 w-full h-full bg-dark-200 rounded-lg flex items-center justify-center" data-id="element-222">
          <div className="text-gold/50 text-sm" data-id="element-223">Cargando video...</div>
        </div>}
    </div>;
}
export function Testimonials() {
  const testimonials = [{
    quote: "Sentí que iba a aguas profundas... una sensación de paz profunda. A los pocos días sentí que salía de mi cuerpo, una paz que me ayudó a mantener el foco. Empezaron a pasar lo que yo llamo 'diosidencias', llamadas de personas para resolver cosas que estaba buscando.",
    name: 'Blas Miliani',
    result: 'Claridad y sincronicidad.',
    videoUrl: 'https://player.vimeo.com/video/1176735931?h=938256e80e'
  }, {
    quote: 'Entendí que la partida de mi bebé fue un regalo de Dios. Llevaba meses en la oscuridad tras perder a mi hijo. En la primera semana de meditaciones volví a encontrar mi centro, la esperanza y las ganas de vivir. Gabriel, estás impactando mi vida de una forma inexplicable.',
    name: 'Rafaela',
    result: 'Sanación de duelo profundo.',
    videoUrl: 'https://player.vimeo.com/video/1176735884?h=1cec32e728'
  }, {
    quote: 'Ya estoy facturando dinero online y siento una evolución rápida. Trabajaba en construcción y no sabía usar una computadora. Gracias a Gabriel y estas meditaciones, mi mente cambió al 100%. Siento una claridad que nunca había experimentado.',
    name: 'Andy Morales',
    result: 'Cambio de identidad y éxito financiero.',
    videoUrl: 'https://player.vimeo.com/video/1176735800?h=ddc7e0effa'
  }];
  return <section className="py-12 px-4 bg-dark" data-id="element-224">
      <div className="max-w-6xl mx-auto" data-id="element-225">
        <p className="text-[13px] uppercase tracking-[0.1em] text-gold text-center mb-6" data-id="element-226">
          Testimonios
        </p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-227">
          {testimonials.map((t, i) => <div key={i} className="bg-dark-300 border border-gold/40 p-6 rounded-lg relative flex flex-col h-full" data-id="element-228">
              <QuoteIcon className="w-8 h-8 text-gold/50 mb-4" data-id="element-229" />

              {/* Video embed if available - Lazy loaded */}
              {t.videoUrl && <LazyVideo videoUrl={t.videoUrl} name={t.name} data-id="element-230" />}

              <div className="flex-grow" data-id="element-231">
                <p className="text-body text-[15px] leading-relaxed mb-6" data-id="element-232">
                  "{t.quote}"
                </p>
              </div>
              <div className="mt-auto border-t border-divider pt-4" data-id="element-233">
                <p className="text-body font-bold text-base" data-id="element-234">{t.name}</p>
                <span className="inline-block mt-2 text-xs text-gold border border-gold/60 rounded-full px-3 py-1" data-id="element-235">
                  {t.result}
                </span>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}